import { useEffect, useRef, useState } from "react";
import { Menu, X, CreditCard, Building2, TrendingUp } from "lucide-react";
import { useNavigate } from "react-router-dom";
import ROUTES from "../../../../constants/RouteData";
import MobileMenu from "../../../../components/mobileMenu/mobilemenu";

export default function NavBar() {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const mobileMenuRef = useRef(null);
  const navigate = useNavigate();

  const toggleMenu = () => {
    setMobileMenuOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isMobileMenuOpen &&
        mobileMenuRef.current &&
        !mobileMenuRef.current.contains(event.target)
      ) {
        setMobileMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isMobileMenuOpen]);

  const handleLinkClick = (path) => {
    setMobileMenuOpen(false);
    navigate(path);
  };

  return (
    <header className="w-full max-w-[1440px] mx-auto px-4 md:px-8 lg:px-16 xl:px-24 my-[20px] flex justify-between items-center py-4 z-50 relative">
      <img
        src="/assets/img/Footer logo.png"
        alt="Company Logo"
        height="24"
        width="142"
        className="cursor-pointer"
        onClick={() => {
          navigate(ROUTES.home);
        }}
      />

      <img
        src="/assets/img/menu.png"
        width="23px"
        height="16px"
        className="block md:hidden cursor-pointer"
        onClick={toggleMenu}
        alt="Menu Icon"
      />

      <nav className="hidden md:flex flex-row text-[16px] space-x-6 lg:space-x-8 text-[#000000] font-medium">
        <button
          onClick={() => handleLinkClick("/personal-loan")}
          className="hover:text-green-500 cursor-pointer transition-colors"
        >
          Personal Loan
        </button>
        <button
          onClick={() => handleLinkClick("/business-loan")}
          className="hover:text-green-500 cursor-pointer transition-colors"
        >
          Business Loan
        </button>
        <button
          onClick={() => {
            window.open("https://payoff.club/", "_blank");
          }}
          className="hover:text-green-500 cursor-pointer transition-colors"
        >
          PayOff
        </button>
      </nav>

      {isMobileMenuOpen && (
        <MobileMenu
          handleClose={() => {
            setMobileMenuOpen(false);
          }}
        />
      )}
    </header>
  );
}